import { extractGraphQLErrors } from "api/extractGraphQLErrors";
import { any, contains, curry, prop } from "ramda";
import slugify from "slugify";

export const isSlugFormatted = (text: string) => slugify(text) === text;

export const containsAll = curry(
  (strings: string[], text: string) =>
    strings.filter(s => !contains(s, text)).length === 0
);

export const isDuplicateSlugError = (err: Error) => {
  const errors = extractGraphQLErrors(err);
  if (
    any<string>(
      containsAll(["duplicate key", "slug_"]),
      errors.map(prop("message"))
    )
  ) {
    return true;
  }
  return false;
};
